import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Button from '../../../components/ui/Button';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';

const HeroBanner = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const banners = [
    {
      id: 1,
      title: "Fresh Groceries Delivered",
      subtitle: "Get farm-fresh produce delivered to your doorstep",
      image: "https://images.unsplash.com/photo-1542838132-92c53300491e?w=1200&h=400&fit=crop",
      ctaText: "Shop Now",
      ctaLink: "/product-catalog-category-browse",
      bgColor: "bg-gradient-to-r from-primary to-secondary"
    },
    {
      id: 2,
      title: "Weekly Deals & Offers",
      subtitle: "Save up to 30% on selected items this week",
      image: "https://images.pexels.com/photos/264636/pexels-photo-264636.jpeg?w=1200&h=400&fit=crop",
      ctaText: "View Deals",
      ctaLink: "/product-catalog-category-browse?category=deals",
      bgColor: "bg-gradient-to-r from-accent to-warning"
    },
    {
      id: 3,
      title: "Organic & Natural",
      subtitle: "Discover our premium organic product collection",
      image: "https://images.pixabay.com/photo/2017/05/11/19/44/fresh-2305192_1280.jpg?w=1200&h=400&fit=crop",
      ctaText: "Explore Organic",
      ctaLink: "/product-catalog-category-browse?category=organic",
      bgColor: "bg-gradient-to-r from-secondary to-primary"
    }
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % banners.length);
    }, 5000);

    return () => clearInterval(timer);
  }, [banners.length]);

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % banners.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + banners.length) % banners.length);
  };

  return (
    <div className="relative w-full h-64 md:h-80 lg:h-96 overflow-hidden rounded-card mb-8">
      {/* Banner Slides */}
      <div 
        className="flex transition-transform duration-500 ease-in-out h-full"
        style={{ transform: `translateX(-${currentSlide * 100}%)` }}
      >
        {banners.map((banner) => (
          <div key={banner.id} className="w-full h-full flex-shrink-0 relative">
            <div className={`absolute inset-0 ${banner.bgColor} opacity-90 z-10`}></div>
            <Image
              src={banner.image}
              alt={banner.title}
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 z-20 flex items-center justify-center text-center px-4">
              <div className="max-w-2xl">
                <h1 className="font-heading font-heading-bold text-2xl md:text-4xl lg:text-5xl text-white mb-4">
                  {banner.title}
                </h1>
                <p className="font-body text-base md:text-lg text-white opacity-90 mb-6">
                  {banner.subtitle}
                </p>
                <Link to={banner.ctaLink}>
                  <Button variant="primary" size="lg">
                    {banner.ctaText}
                  </Button>
                </Link>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Navigation Arrows */}
      <button
        onClick={prevSlide}
        className="absolute left-4 top-1/2 transform -translate-y-1/2 z-30 w-10 h-10 bg-white bg-opacity-20 hover:bg-opacity-30 rounded-full flex items-center justify-center transition-smooth"
        aria-label="Previous slide"
      >
        <Icon name="ChevronLeft" size={20} color="white" />
      </button>
      <button
        onClick={nextSlide}
        className="absolute right-4 top-1/2 transform -translate-y-1/2 z-30 w-10 h-10 bg-white bg-opacity-20 hover:bg-opacity-30 rounded-full flex items-center justify-center transition-smooth"
        aria-label="Next slide"
      >
        <Icon name="ChevronRight" size={20} color="white" />
      </button>

      {/* Dots Indicator */}
      <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 z-30 flex space-x-2">
        {banners.map((_, index) => (
          <button
            key={index}
            onClick={() => goToSlide(index)}
            className={`w-3 h-3 rounded-full transition-smooth ${
              index === currentSlide ? 'bg-white' : 'bg-white bg-opacity-50'
            }`}
            aria-label={`Go to slide ${index + 1}`}
          />
        ))}
      </div>
    </div>
  );
};

export default HeroBanner;